import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWaivePensionIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	fill: "none",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 1.5,
	stroke: "currentColor",
	viewBox: "0 0 16 16",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M9.75 10.5C9.5 11.25 8.83985 11.75 8 11.75C6.5 11.75 5.75 10 5.75 8C5.75 6 6.5 4.25 8 4.25C8.83985 4.25 9.5 4.75 9.75 5.5M4.75 6.75H7.25M4.75 9.25H7.25" }),
		/* @__PURE__ */ _jsx("circle", {
			cx: 8,
			cy: 8,
			r: 6.25
		}),
		/* @__PURE__ */ _jsx("path", { d: "M3.75 12.25L12.25 3.75" })
	]
});
export default SvgWaivePensionIcon;
